<template>
  <b-modal
    id="modal-create-holiday"
    ref="modal-create-holiday"
    title="Add Holiday"
    ok-title="Add"
    cancel-title="Cancel"
    @ok="handleOk"
    @hidden="handleHidden"
    size="md"
    :ok-disabled="creatingHoliday"
  >
    <b-form @submit.prevent="handleOk">
      <b-form-group label-for="holiday-name">
        <template #label>
          Holiday Name <span class="text-danger">*</span>
        </template>
        <b-form-input
          id="holiday-name"
          v-model="holidayForm.holiday"
          placeholder="Enter holiday name"
          :state="nameState"
          :disabled="creatingHoliday"
        />
        <b-form-invalid-feedback :state="nameState">
          Holiday name is required.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-for="holiday-date">
        <template #label>
          Date <span class="text-danger">*</span>
        </template>
        <b-form-input
          id="holiday-date"
          v-model="holidayForm.date"
          type="date"
          :state="dateState"
          :disabled="creatingHoliday"
        />
        <b-form-invalid-feedback :state="dateState">
          Date is required.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Year" label-for="holiday-year">
        <b-form-input
          id="holiday-year"
          v-model="holidayForm.year"
          type="number"
          :min="new Date().getFullYear()"
          :max="new Date().getFullYear() + 1"
          placeholder="Enter year (optional)"
          :disabled="creatingHoliday"
        />
      </b-form-group>
      <b-form-group label-for="holiday-location">
        <template #label>
          Location <span class="text-danger">*</span>
        </template>
        <b-form-select
          id="holiday-location"
          v-model="holidayForm.location"
          :options="locationOptions"
          :state="locationState"
          :disabled="creatingHoliday"
        >
          <template #first>
            <option :value="null">Select Location</option>
          </template>
        </b-form-select>
        <b-form-invalid-feedback :state="locationState">
          Location is required.
        </b-form-invalid-feedback>
      </b-form-group>
      <div v-if="creatingHoliday" class="text-center">
        <b-spinner variant="primary" size="sm" class="mr-2" />
        <span class="text-muted">Adding holiday...</span>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'CreateHolidayModal',
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback, BSpinner,
  },
  props: {
    holidayForm: { type: Object, required: true },
    creatingHoliday: { type: Boolean, default: false },
    locationOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      submitAttempted: false,
    }
  },
  computed: {
    hasName() {
      return !!(this.holidayForm.holiday && String(this.holidayForm.holiday).trim())
    },
    hasDate() {
      return !!this.holidayForm.date
    },
    hasLocation() {
      return !!this.holidayForm.location
    },
    nameState() {
      if (!this.submitAttempted) return null
      return this.hasName
    },
    dateState() {
      if (!this.submitAttempted) return null
      return this.hasDate
    },
    locationState() {
      if (!this.submitAttempted) return null
      return this.hasLocation
    },
  },
  methods: {
    isValid() {
      return this.hasName && this.hasDate && this.hasLocation
    },
    showValidationToast() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Validation Error',
          icon: 'AlertCircleIcon',
          variant: 'warning',
          text: 'Please fill in holiday name, date, and location.',
        },
      })
    },
    handleOk(bvModalEvt) {
      if (bvModalEvt && typeof bvModalEvt.preventDefault === 'function') {
        bvModalEvt.preventDefault()
      }
      this.submitAttempted = true
      if (!this.isValid()) {
        this.showValidationToast()
        return
      }
      this.$emit('ok', bvModalEvt)
    },
    handleHidden() {
      this.submitAttempted = false
      this.$emit('hidden')
    },
  },
}
</script>
